// extracted by mini-css-extract-plugin
export default {"title":"styles_title__bWQVY","card":"styles_card__IqV9A","recordLabel":"styles_recordLabel__kLOpE","actions":"styles_actions__sc00K"};